 

import React from "react"
import PropTypes from "prop-types"
import OnVisible from 'react-on-visible';
import '../css/resource.css'



const ResourcesWrapper = ({ children }) => {
 

  return (
      <OnVisible className='resources-wrapper'>
  
<div className='resources'>{children}</div></OnVisible>
  )
}

ResourcesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ResourcesWrapper
